import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=231aac23"
import script from "./accommodation.vue?vue&type=script&lang=js"
export * from "./accommodation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports